import type { Awaitable, } from "@vueuse/core"
import type { CheckboxGroupProps, SelectProps, SelectV2Props, TreeComponentProps, } from "element-plus"
import type { Component, } from "vue"
import type { VxeSelectProps as VxePcSelectProps, } from "vxe-pc-ui"
import type { ElCascaderProps as CascaderProps, } from "@/components/ElCascader"

export type ElSelectProps = Partial<Omit<SelectProps, "modelValue">>
export type ElCheckboxGroupProps = Partial<Omit<CheckboxGroupProps, "modelValue">>
export type ElCascaderProps = Partial<Omit<CascaderProps, "modelValue" | "filterMethod">>
export type ElSelectV2Props = Partial<Omit<SelectV2Props, "modelValue" | "autocomplete">>
export type ElTreeProps = Partial<TreeComponentProps>
export type VxeSelectProps = Partial<Omit<VxePcSelectProps, "modelValue" | "size" | "filterMethod" | "remoteMethod" | "prefixIcon">>

interface FieldConfig {
  label: string
  value: string
  disabled?: string
  children?: string
}

export interface ApiConfig<P = any, R = any,> {
  config?: FieldConfig
  api: (params?: P) => Promise<R | undefined>
}

export interface OptionItem {
  children?: OptionItem[]
  disabled?: boolean
  label?: string | number
  value?: string | number
  [name: string]: any
}

export type Options = OptionItem[] | string[] | number[]

export type ModelValue = any[] | string | number | boolean | Record<string, any> | undefined

export type Props<P = any, R = any,> = {
  cacheKey?: string
  modelValue?: ModelValue
  /**
   * 组件
   */
  component?: Component
  childComponent?: Component
  /**
   * 接口配置
   */
  apiConfig?: ApiConfig<P, R>
  /**
   * 是否立即执行
   */
  immediate?: boolean
  /**
   * 接口请求参数
   */
  params?: P
  /**
   * 接口请求之前的回调函数，参数为传入的参数，根据返回结果判断是否进行请求
   */
  beforeFetch?: (params: P) => Awaitable<boolean>
  /**
   * 接口请求之后的回调函数，返回结果将作为 options 传递给formatOptions
   */
  afterFetch?: (res?: R) => Awaitable<any[]>
  /**
   * 组件的v-model属性名，默认为modelValue，可自由修改
   */
  modelPropName?: string
  /**
   * 是否缓存数据
   */
  cacheData?: boolean
} & ElSelectProps & ElCheckboxGroupProps & ElSelectV2Props & ElCascaderProps & ElTreeProps

export const defaultProps = {
  modelPropName: "modelValue",
  component: () => ElSelect,
  immediate: true,
  beforeFetch: () => true,
  afterFetch: (res: any,) => {
    return res?.data ?? (Array.isArray(res,) ? res : [])
  },
  apiConfig: undefined,
  cacheData: true,

  // ElCascader
  persistent: true,
  teleported: true,
  validateEvent: true,
}
